import { render, staticRenderFns } from "./InfoUpdate.vue?vue&type=template&id=2a9e670e&scoped=true"
import script from "./InfoUpdate.vue?vue&type=script&lang=js"
export * from "./InfoUpdate.vue?vue&type=script&lang=js"
import style0 from "./InfoUpdate.vue?vue&type=style&index=0&id=2a9e670e&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a9e670e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/pppppat/Documents/GitHub/sp-web-v2/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a9e670e')) {
      api.createRecord('2a9e670e', component.options)
    } else {
      api.reload('2a9e670e', component.options)
    }
    module.hot.accept("./InfoUpdate.vue?vue&type=template&id=2a9e670e&scoped=true", function () {
      api.rerender('2a9e670e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/business/platformManagement/accountManagement/accountNumManagement/dialog/InfoUpdate.vue"
export default component.exports